import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import React from 'react'
import { getButtonTestId } from './getButtonTestId'

/** @notExported */
interface SaveButtonProps {
  /** Action to perform on click. */
  clickAction: () => void
  /** Validation state. */
  valid: boolean
  /** Button label. */
  label: React.ReactNode
  /** Disabled state. */
  disabled?: boolean
  /** Loading state. */
  loading?: boolean
  /** Button color. */
  color?: 'success' | 'inherit' | 'primary' | 'secondary' | 'error' | 'info' | 'warning' | 'newPrimary' | undefined
  /** Test id of the button. */
  testId?: string
}

/**
 * Save button.
 *
 * @returns Save button component.
 * @notExported
 * @category Buttons
 */
const SaveButton: React.FC<SaveButtonProps> = ({
  clickAction,
  valid,
  label,
  disabled = false,
  loading,
  color,
  testId,
}) => {
  const resolvedTestId = getButtonTestId({ fallback: 'button-save', label, testId })
  const ariaLabel = typeof label === 'string' ? label : 'save'

  return (
    <Button
      data-testid={resolvedTestId}
      variant="contained"
      color={color ? color : 'success'}
      aria-label={ariaLabel}
      disabled={!valid || disabled}
      onClick={() => clickAction()}
    >
      {loading ? <CircularProgress size={24} style={{ color: 'white' }} /> : label}
    </Button>
  )
}

export default SaveButton
